import { FunctionComponent } from 'react';

import { Form } from '@kanda-libs/ks-component-ts';
import { Button, Loader } from '@kanda-libs/ks-design-library';

import Profile from 'components/shared/Profile';
import WorkTypesSelect from 'components/shared/WorkTypesSelect';

import useCompanyWorkTypesForm from './useCompanyWorkTypesForm';

const CompanyWorkTypes: FunctionComponent = function () {
  const { form, onSubmit, isSubmitting } = useCompanyWorkTypesForm();

  return (
    <Profile.Section title="Company work types">
      <Form form={form} onSubmit={onSubmit} id="staff-company-work-types">
        <WorkTypesSelect
          title="Select company work types"
          name="work_types"
          alwaysActive
        />
        <Button.Text
          label="Update work types"
          id="staff-company-work-types-submit"
          submit
          disabled={isSubmitting}
        />
        <Loader isLoading={isSubmitting} />
      </Form>
    </Profile.Section>
  );
};

export default CompanyWorkTypes;
